import { createAsyncThunk } from "@reduxjs/toolkit";
import getAxios from "../helpers/axiosInterceptor";
import { API_ROUTES_PATHS } from "../utils/constant";

// Method to get all tasks.
export const getAllTasks = createAsyncThunk(
  "client/getAllTasks",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.GET_ALL_TASKS}`, {
        params: model?.query,
      });

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to create new task (Master Data)
export const createTask = createAsyncThunk(
  "task/createTask",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(`${API_ROUTES_PATHS.CREATE_TASK}`, model);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to update  task (Master Data)
export const updateTask = createAsyncThunk(
  "task/updateTask",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.CREATE_TASK}/${model?.id}`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get master tasks.
export const getMasterTasks = createAsyncThunk(
  "task/getMasterTasks",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.GET_MASTER_TASK}`);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get task by ID.
export const getTaskById = createAsyncThunk(
  "task/getTaskById",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.GET_TASK_BY_ID}/${model}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get task triggers.
export const getTaskTriggers = createAsyncThunk(
  "client/getTaskTriggers",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.GET_TASK_TRIGGERS}`, {
        params: model?.query,
      });

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to update  task (Master Data)
export const updateTaskConfig = createAsyncThunk(
  "task/updateTaskConfig",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.UPDATE_TASK_CONFIG}`,
        model
      );

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// ---------------------------------------- V2Tasks and Outcome API'S FORWORKFLOW  -------------------------------------------
//Method to create Tasks V2 for FORWORKFLOW
export const createTaskV2 = createAsyncThunk(
  "task/createTaskV2",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(`${API_ROUTES_PATHS.V2_TASK}`, model);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// Method to create outcome V2 for task FORWORKFLOW
export const createOutcome = createAsyncThunk(
  "outcome/createOutcome",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.TASK_OUTCOME}`,
        model
      );

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// function to create outcome V2 for task FORWORKFLOW
export const getOutcome = createAsyncThunk(
  "outcome/getOutcome",
  async ({ instructionTypeId }, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.TASK_OUTCOME}`, {
        params: {
          instructionTypeId,
        },
      });

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// function to create outcome V2 for task FORWORKFLOW
export const deleteOutcome = createAsyncThunk(
  "outcome/deleteOutcome",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().delete(
        `${API_ROUTES_PATHS.TASK_OUTCOME}/${model}`
      );

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// function to get all task V2 FORWORKFLOW creation
export const getTasksV2 = createAsyncThunk(
  "task/getTasksV2",
  async ({ isSubTask, instructionTypeId }, thunkApi) => {
    try {
      const res = await getAxios().get(`${API_ROUTES_PATHS.V2_TASK}`, {
        params: {
          isSubTask,
          instructionTypeId,
        },
      });

      return res?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get all task V2 FORWORKFLOW
export const getTasksV2ById = createAsyncThunk(
  "task/getTasksV2ById",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.V2_TASK}/${model}`);

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to update task V2 FORWORKFLOW
export const updateTasksV2 = createAsyncThunk(
  "task/updateTasksV2",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.V2_TASK}/${model?.id}`,
        model
      );

      const responseData = res?.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// -----------------------------V2 INSTRUCTION TASK BRANCHING DASHBAORD API'S FORWORKFLOW ---------------------------------
// function to get all v2 tasks for InstructionDashboard FORWORKFLOW
export const getAllV2Tasks = createAsyncThunk(
  "task/getAllTasks",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.V2_GET_ALL_TASKS}/${model}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Function to complete/pick/drop v2 tasks. FORWORKFLOW
export const completeV2Task = createAsyncThunk(
  "task/completeV2Task",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.V2_TASK_COMPLETE}/${model.id}/allocateOrCompleteTaskV2`,
        model.payload
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// Function to delete v2 tasks. FORWORKFLOW
export const deleteV2Task = createAsyncThunk(
  "task/deleteV2Task",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().delete(
        `${API_ROUTES_PATHS.V2_TASK}/${model}`,
        model.payload
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// -----------------------------V2 GET ALL TASKS FOR CREATE/UPDATE USER AND PRODUCTS API'S FORWORKFLOW ---------------------------
// method to get tasks of active flow V2 FORWORKFLOW
export const getActiveFlowV2Tasks = createAsyncThunk(
  "client/getActiveFlowV2Tasks",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.GET_ALL_TASKS}/${API_ROUTES_PATHS.V2_GET_ACTIVEFLOW_TASKS}`,
        {
          params: model?.query,
        }
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
